import { format, parseISO } from "date-fns";
const dateFormat = "MM/dd/yyyy HH:mm:ss";

const getCurrentDate = () => {
  return format(parseISO(new Date().toISOString()), dateFormat);
};

const trackEvent = (event, payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...payload,
  });
};

export const trackNewProposal = () => {
  trackEvent("new_proposal", {
    new_proposal_create: "success",
    new_proposal_creation_date: getCurrentDate(),
  });
};

export const trackCategorySelect = (strategy_category) => {
  trackEvent("strategy_category_select", {
    strategy_category,
    strategy_category_select_date: getCurrentDate(),
  });
};

export const trackStrategySelect = (strategy) => {
  trackEvent("strategy_select", {
    strategy,
    strategy_select_date: getCurrentDate(),
  });
};

export const trackPrint = (strategy) => {
  trackEvent("print", {
    print: "success",
    strategy,
    print_date: getCurrentDate(),
  });
};

export const trackDraftOpen = (strategy_category, strategy) => {
  trackEvent("draft_open", {
    strategy_category,
    strategy,
    draft_open_date: getCurrentDate(),
  });
};

export const trackDraftSave = (strategy_category, strategy) => {
  trackEvent("draft_save", {
    strategy_category,
    strategy,
    draft_save_date: getCurrentDate(),
  });
};

export const trackProposalSubmit = (strategy) => {
  trackEvent("proposal_submit", {
    proposal_submit_status: "success",
    strategy,
    proposal_submit_date: getCurrentDate(),
  });
};
